import {Button, Form} from "react-bootstrap";
import Message from "../message";
import {useState} from "react";

const McaFileFilter = () => {
    const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;
    const [mcaCompanyFile, setMcaCompanyFile] = useState("");
    const [mcaFiltersInputFile, setMcaFiltersInputFile] = useState("");
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [status_mcaFileFilter, setStatus_mcaFileFilter] = useState("");

    const submit_mcaFileFilter = async () => {
        setStatus_mcaFileFilter("");

        if (mcaCompanyFile.length <= 0) {
            setStatus_mcaFileFilter("Upload company file!");
        } else if (mcaFiltersInputFile.length <= 0) {
            setStatus_mcaFileFilter("Upload filters input file!");
        } else if (dateFrom === "" || dateTo === "") {
            setStatus_mcaFileFilter("please fill in the date fields!");
        } else {
            setStatus_mcaFileFilter("Processing Files...");

            const formDataMcaFilter = new FormData();
            formDataMcaFilter.append("company_file", mcaCompanyFile);
            formDataMcaFilter.append("filter_input_file", mcaFiltersInputFile);

            const requestOptions = {
                method: "POST",
                body: formDataMcaFilter,
            };

            try {
                const mcaFileFilter_response = await fetch(
                    apiServer +
                    `api/mca_file_filter/upload_files?date_from=${dateFrom}&date_to=${dateTo}`,
                    requestOptions
                );
                const mcaFileFilter_status_id = await mcaFileFilter_response.json();

                const mcaFileFilter_status = mcaFileFilter_status_id.detail
                    ? mcaFileFilter_status_id.detail
                    : mcaFileFilter_status_id;
                setStatus_mcaFileFilter(mcaFileFilter_status);
            } catch (e) {
                console.log(e);
            }
        }
    };

    return (
        <div style={{marginTop: "20px"}}>
            <Form>
                <p style={{color: "darkslategray", fontWeight: 500}}>Company File</p>

                <Form.Control
                    type="file"
                    onChange={(e) => setMcaCompanyFile(e.target.files[0])}
                />

                <p
                    style={{marginTop: "15px", color: "darkslategray", fontWeight: 500}}
                >
                    Filters Input File
                </p>

                <Form.Control
                    type="file"
                    onChange={(e) => setMcaFiltersInputFile(e.target.files[0])}
                />
            </Form>

            <p
                style={{
                    marginTop: "15px",
                    marginLeft: "3px",
                    fontWeight: 500,
                    color: "darkslategray",
                }}
            >
                Date From / To
            </p>

            <input
                type="date"
                style={{
                    borderRadius: "3px",
                    borderColor: "lightgray",
                    padding: "3px 6px",
                    marginLeft: "5px",
                }}
                onChange={(e) => {
                    setDateFrom(e.target.value);
                    console.log(dateFrom);
                }}
            />

            <input
                type="date"
                style={{
                    borderRadius: "3px",
                    borderColor: "lightgray",
                    padding: "3px 6px",
                    marginLeft: "5px",
                }}
                onChange={(e) => setDateTo(e.target.value)}
            />

            <div style={{display: "inline-block"}}>
                <Button
                    style={{
                        marginTop: "1.25rem",
                        marginRight: "1rem",
                        backgroundColor: "#3a4c7a",
                        border: "none",
                    }}
                    href="./templates/Pincodes-Input.xlsx"
                    download
                >
                    Download Template
                </Button>
                <Button
                    variant="primary"
                    type="button"
                    style={{marginTop: "20px"}}
                    onClick={() => submit_mcaFileFilter()}
                >
                    Submit
                </Button>
            </div>

            {Message(status_mcaFileFilter, setStatus_mcaFileFilter)}
        </div>
    );
};

export default McaFileFilter;
